import React from 'react';
import { ArrowDownIcon, ArrowUpIcon, ArrowUpDownIcon } from 'lucide-react';
import { SortDirection } from '../../hooks/useSortableData';
interface SortableTableHeaderProps {
  label: string;
  sortKey: string;
  currentSortKey?: string | null;
  currentDirection?: SortDirection;
  onSort: (key: string) => void;
  className?: string;
  align?: 'left' | 'center' | 'right';
}
export function SortableTableHeader({
  label,
  sortKey,
  currentSortKey,
  currentDirection,
  onSort,
  className = '',
  align = 'left'
}: SortableTableHeaderProps) {
  const isActive = currentSortKey === sortKey;
  const alignmentClass = align === 'right' ? 'justify-end text-right' : align === 'center' ? 'justify-center text-center' : 'justify-start text-left';
  return <th className={`px-5 py-4 text-xs font-semibold text-slate-500 uppercase font-heading cursor-pointer hover:bg-slate-100/50 transition-colors group select-none ${className}`} onClick={() => onSort(sortKey)} data-id="element-317">
      <div className={`flex items-center gap-1.5 ${alignmentClass}`} data-id="element-318">
        <span data-id="element-319">{label}</span>
        <span className="inline-flex flex-col" data-id="element-320">
          {isActive ? currentDirection === 'asc' ? <ArrowUpIcon className="w-3.5 h-3.5 text-blue-600" data-id="element-321" /> : <ArrowDownIcon className="w-3.5 h-3.5 text-blue-600" data-id="element-322" /> : <ArrowUpDownIcon className="w-3.5 h-3.5 text-slate-300 group-hover:text-slate-400 transition-colors" data-id="element-323" />}
        </span>
      </div>
    </th>;
}